import { render } from "./Purchases.vue?vue&type=template&id=8a86d72e&scoped=true"
import script from "./Purchases.vue?vue&type=script&lang=js"
export * from "./Purchases.vue?vue&type=script&lang=js"

import "./custom-purchases.scss?vue&type=style&index=0&id=8a86d72e&lang=scss&scoped=true"
import "./Purchases.vue?vue&type=style&index=1&id=8a86d72e&lang=scss&scoped=true"
import "./Purchases.vue?vue&type=style&index=2&id=8a86d72e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a86d72e"]])

export default __exports__